const NavbarData = [
  {
    name: "Home",
    url: "/",
    id: "",
  },
  {
    name: "About us",
    url: "/about",
    id: "",
    subMenu: [
      {
        name: "Our Strength",
        url: "/about",
        id: "#strength",
      },
      {
        name: "Our Mission",
        url: "/about",
        id: "#mission",
      },
      {
        name: "Our Vision",
        url: "/about",
        id: "#vision",
      },
      {
        name: "Our Team",
        url: "/about",
        id: "#team",
      },
    ],
  },
  {
    name: "Our Services",
    url: "/business",
    id: "",
    subMenu: [

       {
        name: "Flow Assurance ",
        url: "/business",
        id: "#flow",
      },
      {
        name: "Process Engineering Support",
        url: "/business",
        id: "#process",
      },
            
 
     
    ],
  },
  {
    name: "Case Studies",
    url: "/CaseStudies",
    id: "",
  },

  {
    name: "Toolkit",
    url: "/toolkit",
    id: "",
  },


  {
    name: "Contact Us",
    url: "/contact",
    id: "",
    subMenu: [
      {
        name: "Email",
        url: "/contact",
        id: "#email",
      },
      {
        name: "Phone / Whatsapp",
        url: "/contact",
        id: "#phone",
      },
      {
        name: "Contact Form",
        url: "/contact",
        id: "#form",
      },
    ],
  },
];

export default NavbarData;
